import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var Icon = function(props) {
    // Define the style with margin-bottom of 8px
    // const iconStyle = {
    //   marginBottom: '8px',
    // };
    return /*#__PURE__*/ _jsx("img", {
        src: "/images/freeswap.svg",
        alt: "logo",
        width: 120,
        height: 50
    });
};
export default Icon;
